import React from "react";

import { useParams } from "../../../generic/routing";
import type { MONITORS_PATH } from "../../Routes";

import { MonitorAddBreadcrumb } from "./MonitorAddBreadcrumb";
import { MonitorCreateBreadcrumb } from "./MonitorCreateBreadcrumb";
import { MonitorEditorBreadcrumb } from "./MonitorEditorBreadcrumb";
import { MonitorsIndexBreadcrumb } from "./MonitorsIndexBreadcrumb";

export const MonitorsBreadcrumb: React.FC = () => {
	const { id, monitorFunctionIdentifier } = useParams<typeof MONITORS_PATH>();

	return (
		<>
			<MonitorsIndexBreadcrumb />
			{id === "new" && <MonitorAddBreadcrumb />}
			{monitorFunctionIdentifier != null && (
				<MonitorCreateBreadcrumb monitorFunctionIdentifier={monitorFunctionIdentifier} />
			)}
			{id !== "new" && id != null && <MonitorEditorBreadcrumb id={id} />}
		</>
	);
};
